import { POST_JSON, GET, DELETE, PATCH_JSON } from '../utils/axios';
import { API_PREFIXES } from './config';

// --- Auth ---
// POST /auth/login
export const getLogin = (data = {}) => {
  return POST_JSON(`${API_PREFIXES.AUTH}/login`, data);
};
// GET /auth/me
export const getCurrentAdmin = () => {
  return GET(`${API_PREFIXES.AUTH}/me`, {});
};

// --- Stats ---
// GET /stats/dashboard
export const getStatsDashboard = () => {
  return GET(`${API_PREFIXES.STATS}/dashboard`, {});
};
// GET /stats/regions/{region}
export const getStatsRegions = (region: string, data: { from: number; to: number }) => {
  return GET(`${API_PREFIXES.STATS}/regions/${region}`, data);
};
// 注：POST /stats/report 不在这里。它要 X-API-Key（区域栈上报专用），
// 管理台带 Admin JWT 调会被拒——不是管理台能用的接口。

// --- Factory ---
// GET /factory/devices
export const getFactoryDevices = (
  data: {
    status?: string;
    model_code?: string;
    batch_number?: string;
    page?: number;
    page_size?: number;
  } = {}
) => {
  return GET(`${API_PREFIXES.ADMIN}/factory/devices`, data);
};
// 注：admin 侧只有这一个只读接口。Swagger 里没有 DELETE /admin/factory/devices/{id}，
// 别再加回来——之前那个函数指向一个不存在的路径，调用必然 404。

// --- Admin - Factory Keys ---
// GET /admin/factory-keys
export const getFactoryKeys = () => {
  return GET(`${API_PREFIXES.ADMIN}/factory-keys`, {});
};
// POST /admin/factory-keys
export const createFactoryKey = (data: { name: string }) => {
  return POST_JSON(`${API_PREFIXES.ADMIN}/factory-keys`, data);
};
// DELETE /admin/factory-keys/{id}
export const revokeFactoryKey = (id: string) => {
  return DELETE(`${API_PREFIXES.ADMIN}/factory-keys/${id}`, {});
};

// --- Admin - Tenants ---
// GET /admin/tenants
export const getTenants = (
  data: {
    status?: string;
    q?: string;
    limit?: number;
    offset?: number;
  } = {}
) => {
  return GET(`${API_PREFIXES.ADMIN}/tenants`, data);
};
// POST /admin/tenants
export const createTenant = (data: {
  slug: string;
  display_name: string;
  base_url: string;
  owner_email: string;
  owner_name?: string;
  notes?: string;
}) => {
  return POST_JSON(`${API_PREFIXES.ADMIN}/tenants`, data);
};
// GET /admin/tenants/{id}
export const getTenant = (id: string) => {
  return GET(`${API_PREFIXES.ADMIN}/tenants/${id}`, {});
};
// PATCH /admin/tenants/{id}
export const updateTenant = (
  id: string,
  data: {
    display_name?: string;
    base_url?: string;
    owner_email?: string;
    owner_name?: string;
    notes?: string;
  }
) => {
  return PATCH_JSON(`${API_PREFIXES.ADMIN}/tenants/${id}`, data);
};
// DELETE /admin/tenants/{id}
export const deleteTenant = (id: string) => {
  return DELETE(`${API_PREFIXES.ADMIN}/tenants/${id}`, {});
};
// POST /admin/tenants/{id}/status
export const changeTenantStatus = (id: string, status: 'active' | 'suspended' | 'archived') => {
  return POST_JSON(`${API_PREFIXES.ADMIN}/tenants/${id}/status`, { status });
};
// GET /admin/tenants/{id}/claim-tokens
export const getTenantClaimTokens = (id: string, include: 'active' | 'all' = 'active') => {
  return GET(`${API_PREFIXES.ADMIN}/tenants/${id}/claim-tokens`, { include });
};
// POST /admin/tenants/{id}/claim-tokens
export const issueTenantClaimToken = (id: string, data: { max_claims: number; notes?: string }) => {
  return POST_JSON(`${API_PREFIXES.ADMIN}/tenants/${id}/claim-tokens`, data);
};
// DELETE /admin/tenants/{id}/claim-tokens/{tokenId}
export const revokeTenantClaimToken = (id: string, tokenId: string) => {
  return DELETE(`${API_PREFIXES.ADMIN}/tenants/${id}/claim-tokens/${tokenId}`, {});
};

// --- Admin Proxy (Regions) ---
// GET /regions
export const getRegions = () => {
  return GET(`${API_PREFIXES.PROXY}/regions`, {});
};

// --- Firmware ---
export * from './firmware';
